import { UrlConstants } from "../url.constants";
export class ApiPropertyAndLeaseConstants {
    static URL = UrlConstants.API_V2 + "PropertyAndLease";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetPropertyAndLeaseApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GeneratePropertyAndLeaseInvoiceReport";
    static FUNCTION_GET_LESSEES = "GetLesseesPortal";
    static FUNCTION_GET_BUYERS = "GetBuyersPortal";
    static FUNCTION_GET_SELLERS = "GetSellersPortal";
    static FUNCTION_SET_DETAILS = "SetPropertyAndLeaseDetails";
    static FUNCTION_SET_PROPERTIES = "SetPropertyAndLeaseProperties";
    static FUNCTION_GET_MY_AFLA_PORTAL_PROPERTY_AND_LEASE_APPLICATIONS = "GetMyAFLAPortalPropertyAndLeaseApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_RC_APPLICATIONS = "GetAllAFLAPortalPropertyAndLeaseApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalApplication";
}
